import React, { useState } from 'react';
import { WhatsappBannerImage } from './styled';
import Image from 'next/image';

function WhatsappBanner(props) {
  const { data, paddingTop, lactoMamaCategory } = props;
  const [clickEffect, setClickEffect] = useState(false);
  const onClick = () => {
    setClickEffect(true);
    setTimeout(() => {
      setClickEffect(false);
    }, 300);
    window.open(
      'https://wa.me/+917949106625?text=Hi, I have questions about Mylo Lactomama Lactation Granules!',
      '_blank',
    );
  };
  return (
    <WhatsappBannerImage
      paddingTop={paddingTop}
      lactoMamaCategory={lactoMamaCategory}
      className={data?.addClickFunc ? (clickEffect ? 'lowOpacity' : '') : ''}
      onClick={data?.addClickFunc ? onClick : () => {}}
    >
      <Image
        src={data?.banner}
        alt={'Wrapper Whatsapp'}
        className="image"
        quality={90}
        fill
        sizes="100vw"
      />
    </WhatsappBannerImage>
  );
}

export default WhatsappBanner;
